export const iconFontAwesomeCampingTarp = (
	<i className="fa-solid fa-tarp"></i>
);
